import React from 'react';
import Main from './Main';
import Brand from './Brand';
import LegalListContainer from '../containers/LegalListContainer';
import './Home.css';
import HeroContainer from '../containers/HeroContainer';

export default () => (
  <Main>
    <HeroContainer />
    <div className="home-content">
      <section className="section def">
        <Brand type="iso" isLink={false} />
        <div className="def__txt">
          <p>
            <strong>Reconstrucción.pe</strong> es una herramienta para la
            vigilancia y participación ciudadana que permitirá hacer seguimiento
            independiente al proceso de Reconstrucción, en las regiones
            afectadas por el fenómeno del niño costero.
          </p>
        </div>
      </section>
      <section className="section background">
        <h2 className="section-title">Reconstrucción con Cambios</h2>
        <div className="background-grid">
          <div className="background-column">
            <img src="./img/ant1-min.jpg" alt="" />
            <div>
              <h3 className="section-subtitle">El Fenómeno del Niño Costero</h3>
              <p>
                Durante el verano del 2017, nuestro país fue duramente golpeado
                por el Fenómeno de El Niño Costero, condición climática
                producida por el calentamiento anómalo del mar debido al
                debilitamiento de las corrientes de aire frías, que recorren de
                sur a norte las costas del Pacífico Sur.
              </p>
              <p>
                Este fenómeno provocó importantes daños y pérdidas humanas y
                materiales: 159 personas fallecieron, 18 están desaparecidas y
                467 fueron heridas. 879 distritos en 14 regiones fueron
                declarados en emergencia. Se perdieron 41,886 hectáreas de
                cultivo, 433 puentes fueron destruidos, además de 45,525
                kilómetros afectados del sistema vial nacional. Asimismo, 29,281
                viviendas colapsaron y 25,361 no pueden ser habitadas de nuevo.
                La infraestructura de salud y educación también sufrió: 937
                establecimientos de salud y 3222 colegios fueron dañados por el
                evento climático.
              </p>
            </div>
          </div>
          <div className="background-column">
            <img src="img/ant2-min.jpg" alt="" />
            <div>
              <h3 className="section-subtitle">
                El Plan Integral de Reconstrucción con Cambios
              </h3>
              <p>
                Para contrarrestar esta situación, el Gobierno ha puesto en
                marcha el Plan Integral de Reconstrucción con Cambios (PIRCC),
                cuyo presupuesto alcanza los 25,655 millones de soles,
                otorgándose un mayor monto para la recuperación de la
                infraestructura en los sectores transporte (38%), educación
                (10%) y saneamiento (8%). La inversión en el sector agrícola,
                vivienda, salud, construcción de pistas y veredas reciben en
                conjunto una asignación del 20%.
              </p>
              <p>
                Para las regiones del norte que observaremos, el Estado ha
                asignado tres cuartos del total del presupuesto, con Piura
                participando del 29%, La Libertad del 17%, Áncash del 14%,
                Lambayeque del 12% y Cajamarca del 3%. La implementación del
                plan está pensada a través de una arquitectura de entidades
                ejecutoras, la mayoría de las cuales pertenece a los
                ministerios, los gobiernos regionales y los municipios locales.
                Dados los desafíos de la reconstrucción en términos de
                pertinencia de las obras, ritmo de ejecución, así como de
                transparencia y rendición de cuentas, la sociedad civil
                organizada debe equiparse para ejercer sus derechos de
                vigilancia y participación, y así contribuir a que este proceso
                sea eficiente, democrático y libre de corrupción.
              </p>
            </div>
          </div>
          <div className="background-column">
            <img src="img/ant3-min.jpg" alt="" />
            <div>
              <h3 className="section-subtitle">Reconstrucción.pe</h3>
              <p>
                Para contribuir a la rendición de cuentas, acceso a la
                información y la gestión transparente de este proceso, el Grupo
                Propuesta Ciudadana ha diseñado “Reconstrucción.pe”, herramienta
                de monitoreo, análisis y publicación de reportes, verificación
                de datos, y estudios especiales. De esta manera, ofrecemos
                recursos políticos y técnicos a los ciudadanos para ejercer su
                derecho de participación y vigilancia de la Reconstrucción.
              </p>
              <p>
                Así, apostamos por abrir un debate sobre cómo es que la
                Reconstrucción interpela muchos de los tópicos que definen la
                gestión pública en nuestro país. Enfocaremos el gobierno de los
                procesos territoriales (ordenamiento de uso y acceso de recursos
                naturales, adaptación al cambio climático, prevención y manejo
                de desastres, acondicionamiento urbano), la instalación de
                infraestructura (redes de agua y saneamiento, transporte,
                irrigación, energía, regulación de cuencas, salud y educación),
                la diversificación productiva (afectación y oportunidades para
                las experiencias de innovación en marcha, reconstrucción de
                bienes y servicios desde un enfoque productivo), la capacidad
                del Estado (recursos técnicos y burocráticos, innovación de
                políticas públicas, trampas de gestión y capacidad), y la
                transparencia (rendición de cuentas, producción y manejo de la
                información, participación ciudadana efectiva) en clave
                Reconstrucción. Esperamos que, colectivos civiles,
                organizaciones rurales, comunidades de técnicos, funcionarios y
                comunicadores, en suma, todos los ciudadanos interesados en el
                proceso, puedan usar este espacio para identificar las
                oportunidades de cambio de las políticas que los convocan.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section weare">
        <h2 className="section-title">Nosotros</h2>
        <div className="weare-grid">
          <div className="weare__gpc">
            <h3 className="section-subtitle">GPC</h3>
            <div>
              <a
                className="gpc"
                href="http://propuestaciudadana.org.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/nos1-min.jpg" alt="" />
              </a>
              <p>
                El Grupo Propuesta Ciudadana (GPC) es un consorcio de
                organizaciones no gubernamentales que tiene como misión apoyar
                la consolidación del sistema democrático en el Perú,
                contribuyendo a la elaboración de propuestas de políticas para
                una reforma del Estado inclusiva y una adecuada gestión de los
                recursos públicos desde la sociedad civil.
              </p>
            </div>
          </div>
          <div className="weare__partners">
            <h3 className="section-subtitle">Socios del GPC</h3>
            <div className="weare__partners-grid">
              <a
                href="http://www.alter.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/soc1-min.jpg" alt="" />
              </a>
              <a
                href="http://arariwa-microfinanzas.org.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/soc2-min.jpg" alt="" />
              </a>
              <a
                href="http://www.cbc.org.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/soc3-min.jpg" alt="" />
              </a>
              <a
                href="http://ceder.org.pe/web/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/soc4-min.jpg" alt="" />
              </a>
              <a
                href="http://www.desco.org.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/soc5-min.jpg" alt="" />
              </a>
              <a
                href="http://www.cepes.org.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/soc6-min.jpg" alt="" />
              </a>
              <a
                href="http://www.cipca.org.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/soc7-min.jpg" alt="" />
              </a>
              <a
                href="http://www.cedepas.org.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/soc8-min.jpg" alt="" />
              </a>
              <a
                href="http://cedepperu.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/soc9-min.jpg" alt="" />
              </a>
              <a
                href="http://www.iep.org.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/soc10-min.jpg" alt="" />
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="section legal">
        <h2 className="section-title">Marco Legal</h2>
        <div className="legal-grid">
          <LegalListContainer />
        </div>
      </section>
    </div>
  </Main>
);



// WEBPACK FOOTER //
// ./src/components/Home.js